exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".action-menu{position:absolute;right:50%;top:50%;display:none}.action-menu__actions{position:relative;z-index:2;background:#fff;border:.0625rem solid #ccc}.action-menu__actions a,.action-menu__actions div[role=button]{display:block;padding:.75rem;padding-right:3rem;color:#222528;font-size:.875rem;white-space:nowrap;cursor:default}.action-menu__actions a.active,.action-menu__actions div[role=button].active{font-weight:700}.action-menu__cancel{border-top:.0625rem solid #ccc}.action-menu__background{position:fixed;left:0;right:0;top:0;bottom:0;z-index:1}.action-menu svg{height:1.25rem;vertical-align:middle;margin-right:.25rem}.action-menu.active{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ActionMenu/ActionMenu.scss
// module id = 666
// module chunks = 0